import { analytics } from '@/lib/analytics'
import { usePathname } from 'expo-router'
import type React from 'react'
import { useEffect } from 'react'

/** Leverages expo router's page structure to send a page view every time the pathname changes */
export const AnalyticsScreenTracker = ({ children }: { children: React.ReactNode }) => {
	const pathname = usePathname()

	useEffect(() => {
		analytics.trackView(pathname)
	}, [pathname])

	return children
}
